import { useAppDispatch, useAppSelector } from "@/app/store/hooks";
import { cn } from "@/shared/lib/utils";
import Typography from "@/shared/ui/Typography";
import {
    selectModalPresentationLink,
    selectRequestModalFormData,
} from "../model/selects";
import { complatedModalClose } from "../model/slice";

import CloseIcon from "@/assets/icons/app/close.svg?react";
import ComplatedIcon from "@/assets/icons/app/complated.svg?react";

export interface IModalComplatedProps {
    className?: string;
}

export function ModalComplated({ className }: IModalComplatedProps) {
    const dispatch = useAppDispatch();

    const modalFormData = useAppSelector(selectRequestModalFormData);
    const presentaionLink = useAppSelector(selectModalPresentationLink);

    const handleModalClose = () => {
        dispatch(complatedModalClose());
    };

    return (
        <div
            className={cn(
                "fixed z-30 w-screen h-screen overflow-x-hidden overflow-y-auto scrollbar-hide left-0 top-0 bg-light-blue-50 shadow-glass flex justify-center items-center",
                className
            )}
        >
            <div className="relative w-[355px] md:w-[500px] p-[20px] md:p-[40px] rounded-[10px] bg-white-50 shadow-glass">
                <div
                    className="absolute z-10 top-[10px] right-[10px] md:top-[20px] md:right-[20px]
                        w-[36px] h-[36px] md:w-[40px] md:h-[40px] flex justify-center items-center bg-white-50 shadow-glass rounded-full"
                    onClick={handleModalClose}
                >
                    <CloseIcon className="w-[16px] h-[16px] md:w-[20px] md:h-[20px]" />
                </div>

                <div className="flex flex-col items-center gap-[16px] md:gap-[20px]">
                    <ComplatedIcon className="w-[70px] h-[70px]" />
                    <Typography
                        tag="h2"
                        className="text-center !leading-[120%]"
                    >
                        {presentaionLink && modalFormData.download ? (
                            <>
                                Спасибо! Если загрузка файла не началась,
                                нажмите{" "}
                                <a
                                    href={presentaionLink}
                                    download
                                    className="underline text-green"
                                >
                                    ЗДЕСЬ
                                </a>
                                .
                            </>
                            
                        ) : (
                            <>Спасибо! Наш менеджер скоро свяжется с вами!</>
                        )}
                    </Typography>
                </div>
            </div>
        </div>
    );
}
